import { Box, Typography } from '@mui/material';
import React from 'react';

interface InfoCardProps {
  title: string;
  items: { heading: string; value: string }[];
}

export const InfoCard: React.FC<InfoCardProps> = ({ title, items }) => {
  return (
    <Box
      sx={{
        padding: '20px',
        maxWidth: '100%',
        boxSizing: 'border-box',
        paddingLeft: '40px',
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 'bold', fontSize: '20px', marginBottom: '14px' }}
      >
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '30%',
              padding: '14px 0',
            }}
          >
            <Typography
              sx={{ fontSize: '14px', textTransform: 'uppercase', color: '#666' }}
            >
              {item.heading}
            </Typography>
            <Typography sx={{ fontSize: '16px', color: '#000' }}>{item.value}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

interface PeopleDetailViewProps {
  data: {
    title: string;
    items: { heading: string; value: string }[];
  };
}

export const PeopleDetailView: React.FC<PeopleDetailViewProps> = ({ data }) => {
  return <InfoCard title={data.title} items={data.items} />;
};
